import { atomWithReset as atom } from 'jotai/utils';
import { getFilteredData } from '../utils';

export const victimologyState = atom(null);

export const initialVictimologyFilters = {
  search: '',
  country: [],
  sector: [],
  region: [],
  organization: []
};

export const victimologyFiltersState = atom(initialVictimologyFilters);
export const victimologyTempFiltersState = atom(initialVictimologyFilters);

export const filteredVictimologyState = atom(get => {
  const data = get(victimologyState);
  const filters = get(victimologyFiltersState);
  return data ? getFilteredData(data, filters) : null;
});
